import { useEffect, useState } from 'react';
import CustomButton from 'components/CustomInput/Button';
import { getTimeWithTimeZone } from 'utility/general';

const useApplicationDocument = ({ selectedRows, setSelectedRows, applicationDocData }) => {
    const [isDisabledAll, setIsDisabledAll] = useState(false);
    const checkedAll = () => {
        let newSelectedRows = applicationDocData?.result?.reduce((group, curP) => {
            if (!selectedRows.find((item) => item.id === curP.id)) {
                return group.concat(curP);
            }
            return group;
        }, []);
        setSelectedRows([...selectedRows, ...newSelectedRows]);
    };
    const searchDocTypeEnum = (type, row = null) => {
        let docType = '-';
        switch (type) {
            case 0:
                docType = 'Initial Application';
                break;
            case 1:
                docType = 'Amendment Application';
                break;
            case 2:
                docType = 'SUSAR Report';
                break;
            case 3:
                docType = 'Miscellaneous Report';
                break;
            case 4:
                docType = 'Final Report';
                break;
            case 5:
                docType = 'CTC';
                break;
            case 6:
                docType = 'CTI';
                break;
            case 7:
                docType = 'Progress Report';
                break;
            case 8:
                docType = 'Protocol Deviation Report';
                break;
            case 9:
                docType = 'Local SAE Report';
                break;
            default:
                break;
        }
        if (type !== 0 && row?.siteInstruction) {
            docType += ' (' + row.siteInstruction + ')';
        }
        return docType;
    };
    const selectedColumns = [
        { field: 'subNo', headerName: 'Submission No.', width: 180 },
        { field: 'appNo', headerName: 'CRER Application No.', width: 180 },
        { field: 'refNo', headerName: 'IRB/REC Ref No.', width: 280 },
        {
            field: 'confirmDate',
            headerName: 'Confirmed Date',
            width: 200,
            valueGetter: (params) => {
                return params.value ? getTimeWithTimeZone(params.value).format('YYYY-MM-DD') : '-';
            },
        },
        {
            field: 'documentType',
            headerName: 'Document Type',
            width: 240,
            valueGetter: (params) => {
                return searchDocTypeEnum(params.value, params.row);
            },
        },
    ];
    useEffect(() => {
        if (!applicationDocData) return setIsDisabledAll(false);
        setIsDisabledAll(true);
        applicationDocData?.result.forEach((item) => {
            if (!selectedRows.find((ele) => ele.id === item.id)) {
                setIsDisabledAll(false);
                return;
            }
        });
    }, [selectedRows, applicationDocData]);
    const columns = [
        {
            field: 'action',
            headerName: (
                <div>
                    <CustomButton onClick={checkedAll} disabled={isDisabledAll}>
                        Add All
                    </CustomButton>
                </div>
            ),
            disableItemSort: true,
            valueGetter: (params) => {
                const isExist = selectedRows.some((item) => item.id === params.row.id);
                return (
                    <CustomButton
                        disabled={isExist}
                        onClick={() => {
                            if (!isExist) {
                                setSelectedRows([...selectedRows, params.row]);
                            }
                        }}
                    >
                        Add
                    </CustomButton>
                );
            },
        },
        { field: 'subNo', headerName: 'Submission No.', width: 180 },
        { field: 'appNo', headerName: 'CRER Application No.', width: 180 },
        { field: 'refNo', headerName: 'IRB/REC Ref No.', width: 280 },
        {
            field: 'confirmDate',
            headerName: 'Confirmed Date',
            width: 200,
            valueGetter: (params) => {
                return params.value ? getTimeWithTimeZone(params.value).format('YYYY-MM-DD') : '-';
            },
        },
        {
            field: 'documentType',
            headerName: 'Document Type',
            width: 240,
            valueGetter: (params) => {
                // if (!params.value) return '-'
                return searchDocTypeEnum(params.value, params.row);
            },
        },
        // {
        //     field: 'name',
        //     headerName: 'Document Name',
        //     width: 240,
        //     renderCell: (params) => {
        //         return <SHyperLink>{params.row.name}</SHyperLink>;
        //     },
        // },
    ];

    return { columns, selectedColumns };
};

export default useApplicationDocument;
